import {Injectable} from '@angular/core';
import {GridLayoutService} from '@irb-common/interfaces/grid-layout.service';
import {DialogPrAuditComponent} from "@irb/irb-dialogs/dialog-pr-audit/dialog-pr-audit.component";

@Injectable({
    providedIn: 'root'
})
export class DialogPrAuditDialogGridLayoutService implements GridLayoutService<DialogPrAuditComponent> {
    constructor() {
    }

    getFrameworkComponents() {
        return {};
    }

    getColumnDefs() {
        return [{
            headerName: 'Acct #',
            field: 'accNum',
            minWidth: 70,
            sort: 'asc',
            cellRenderer : "cellRendererFormatter",
            comparator: this.customComparator.bind(this),
        },
            {
                headerName: 'Security',
                field: 'securitySymb',
                maxWidth: 120,
                width: 120,
                cellRenderer : "cellRendererFormatter",
                comparator: this.customComparator.bind(this)
            },
            {
                headerName: 'Original Trade',
                field: 'origTrade',
                maxWidth: 180,
                width: 180,
                minWidth:180,
                cellRenderer : "cellRendererFormatter"
            },
            {
                headerName: 'Modified Trade',
                field: 'modifiedTrade',
                maxWidth: 150,
                width: 160,
                minWidth:160,
                cellRenderer : "cellRendererFormatter",
            },
            {
                headerName: 'User ID',
                field: 'userId',
                maxWidth: 100,
                width: 100,
                cellRenderer : "cellRendererFormatter",
                comparator: this.customComparator.bind(this)
            },
            {
                headerName: 'Date/Time',
                field: 'modifiedDate',
                maxWidth: 180,
                minWidth: 180,
                width:160,
                cellRenderer : 'cellRendererFormatter',
                suppressFiltersToolPanel: true,
                comparator: this.sortDate.bind(this)
            }];
    }

    customComparator(valueA: any, valueB: any) {
        let a = valueA;
        let b = valueB;
        if (a === null || typeof a === "undefined") {
            a = '';
        }
        if (b === null || typeof b === "undefined") {
            b ='';
        }
    
        return a.toLowerCase().localeCompare(b.toLowerCase());
    }
    sortDate(a: any, b: any) {
        if (a === null || typeof a === "undefined") {
            return -1;
        } else if (b === null || typeof b === "undefined") {
            return 1;
        } else {
            a=a.replace("ET", "");
            b=b.replace("ET", "");
            a = new Date(a).getTime();
            b = new Date(b).getTime();
            return a < b ? -1 : a > b ? 1 : 0;
        }
    }
}
